/**
 * WorkflowsPage — embeds the Ventin Workflows engine (Node-RED running as its
 * own service) inside the admin shell. The engine validates the same session
 * cookie and is ADMIN-only; VITE_WORKFLOWS_URL points at its public domain.
 */
const WORKFLOWS_URL = import.meta.env.VITE_WORKFLOWS_URL;

export default function WorkflowsPage() {
  if (!WORKFLOWS_URL) {
    return (
      <div className="max-w-2xl mx-auto px-6 py-12">
        <h2 className="text-2xl font-semibold mb-2">Workflows</h2>
        <div className="rounded-lg border bg-card p-6 text-sm space-y-3">
          <p>
            The workflows engine isn't connected yet. It runs as the <code>workflows</code> service
            on Railway (Node-RED).
          </p>
          <ol className="list-decimal pl-5 space-y-1.5">
            <li>Give the workflows service a public domain (or custom subdomain).</li>
            <li>
              Set <code>VITE_WORKFLOWS_URL</code> on the web service to that URL and redeploy.
            </li>
            <li>
              Set <code>COOKIE_DOMAIN</code> on the api service so your sign-in carries over.
            </li>
          </ol>
        </div>
      </div>
    );
  }

  return (
    <iframe
      src={WORKFLOWS_URL}
      title="Ventin Workflows"
      className="w-full h-[calc(100vh-1px)] border-0 bg-white"
    />
  );
}
